import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
import Layout from '../views/layout/Layout'

export const constantRouterMap = [
  {
    path: '/sys/department/index',
    component: Layout,
    children: [
      {
        path: '/sys/department/index',
        component: () => import('@/views/sys/department/index'),
        meta: {title: '部门管理'}
      }
    ]
  },


  {
    path: '/sys/user/index',
    component: Layout,
    name:"user",
    children: [
      {
        path: '/sys/user/index',
        component: () => import('@/views/sys/user/index'),
        meta: {title: '人员管理'}
      }
    ]
  },
      {
    path: '/HospitalManagemen',
    component: Layout,
    name: 'HospitalManagement',
    children: [
      {
        path: '/HospitalManagement',
        component: () => import('@/views/BaseData/HospitalManagement'),
        meta: {title: '医院管理'}
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/SystemManagement',
    component: Layout,
    redirect: '/SystemManagement',
    children: [
      {
        path: 'MenuManagement',
        name: 'MenuManagement',
        component: () => import('@/views/SystemManagement/MenuManagement'),
        meta: {title: '菜单管理',},
      },
      {
        path: 'Role',
        name: 'Role',
        component: () => import('@/views/SystemManagement/Role'),
        meta: {title: '角色管理'}
      }
    ]
  },
  {
    path: '/DataDictionary',
    component: Layout,
    redirect: '/DataDictionary',
    children: [
      {
        path: 'DictionaryManagement',
        name: 'DictionaryManagement',
        component: () => import('@/views/DataDictionary/DictionaryManagement'),
        meta: {title: '字典管理'}
      }
    ]
  },
    {
    path: '/handoverType',
    component: Layout,
    redirect: '/handoverType',
    name:"handoverType",
    children: [
      {
        path: 'handoverType',
        name: 'handoverType',
        component: () => import('@/views/sys/handoverType/index'),
        meta: {title: '交接配置'}
      },
      {
        path: 'handoverPage',
        name: 'handoverPage',
        component: () => import('@/views/sys/handoverPage/index'),
        meta: {title: '交接申请'}
      }
    ]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  },

]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js